import type { FC } from "react";
import React, { memo } from "react";
import useIntegratedGradeSwitcher from "../../utils/integratedGradeSwitcherHooks";
import GradeSwitcher from "./grade-switcher/GradeSwitcher";
import GradeSwitcherSkeleton from "../../../shared-components/css-modules/lexus/organisms/GradeSwitcherSkeleton";
import type { CarMotorizationType } from "../../../../shared-logic/types/CarType";
import { useModalMap } from "../../../../../common-deprecated/containers/ModalProvider";
import { aemGradeSelectorLexusModalMap } from "./modals/modals";

const IntegratedGradeSwitcher: FC<{
    modelId: string;
    selectedGradeBodyId: string;
    selectedMotorization: CarMotorizationType;
    selectedColourId: string;
    onSelect?: (
        carId: string,
        name: string,
        selectedColourId: string,
        selectedColourCode: string,
        carExtras: string[],
    ) => void;
    onKeep?: () => void;
}> = ({ modelId, selectedGradeBodyId, selectedMotorization, selectedColourId, onSelect, onKeep }) => {
    const { fetching } = useIntegratedGradeSwitcher(
        selectedGradeBodyId,
        selectedColourId,
        selectedMotorization,
        modelId,
    );

    useModalMap(aemGradeSelectorLexusModalMap);

    return fetching ? (
        <GradeSwitcherSkeleton />
    ) : (
        <GradeSwitcher selectedGradeBodyId={selectedGradeBodyId} onSelect={onSelect} onKeep={onKeep} />
    );
};

export default memo(IntegratedGradeSwitcher);
